import { useCallback, useMemo } from 'react';
import { useTuiServiceStore } from '../store';
var updateTuiTargetElementDataSelector = function (t) { return t.updateTuiTargetElementData; };
var convertRawDataIntoTargetElementData = function (node) {
    return node instanceof HTMLElement ? { element: node } : node;
};
export function useRegisterTeachingUiTargetElement(elementIdForRefFunction) {
    var updateTuiTargetElementData = useTuiServiceStore(updateTuiTargetElementDataSelector);
    var registerElementFunctionGenerator = useCallback(function (elementId, customRefAssignment) {
        return function (node) {
            var _a;
            var data = convertRawDataIntoTargetElementData(node);
            updateTuiTargetElementData(elementId, data);
            customRefAssignment === null || customRefAssignment === void 0 ? void 0 : customRefAssignment((_a = data === null || data === void 0 ? void 0 : data.element) !== null && _a !== void 0 ? _a : null);
        };
    }, [updateTuiTargetElementData]);
    return useMemo(function () {
        return elementIdForRefFunction
            ? registerElementFunctionGenerator(elementIdForRefFunction)
            : registerElementFunctionGenerator;
    }, [registerElementFunctionGenerator, elementIdForRefFunction]);
}
//# sourceMappingURL=useRegisterTeachingUiTargetElement.js.map